<template>
  <div class="grafico">
    <div class="canvas-wrapper">
      <Line :data="chartData" :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { Line } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, CategoryScale, LinearScale)

export default {
  name: 'ResumenMensualChart',
  components: { Line },
  props: {
    resumenMensual: {
      type: Object,
      required: true
    },
    asesor: {
      type: Object,
      required: true
    }
  },
  computed: {
    chartData() {
      const meses = {
        1: 'Enero', 2: 'Febrero', 3: 'Marzo', 4: 'Abril',
        5: 'Mayo', 6: 'Junio', 7: 'Julio', 8: 'Agosto',
        9: 'Septiembre', 10: 'Octubre', 11: 'Noviembre', 12: 'Diciembre'
      }

      const entries = Object.entries(this.resumenMensual)
        .map(([mes, total]) => ({ mes: parseInt(mes), total }))
        .sort((a, b) => a.mes - b.mes)

      return {
        labels: entries.map(e => meses[e.mes]),
        datasets: [
          {
            label: 'Monto por Mes',
            data: entries.map(e => e.total),
            fill: false,
            borderColor: '#42A5F5',
            backgroundColor: '#42A5F5',
            tension: 0.3,
            pointRadius: 5,
            pointHoverRadius: 7
          }
        ]
      }
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'top' },
          title: {
            display: true,
            text: (this.asesor.first_name != undefined)
              ? `Recuperación de ${this.asesor.first_name} ${this.asesor.last_name} Mensual`
              : 'Recuperación Mensual'
          },
          tooltip: {
            callbacks: {
              label: context => `${context.parsed.y.toLocaleString()} Lps`
            }
          }
        },
        scales: {
          y: {
            beginAtZero: true,
            ticks: {
              callback: value => `${value.toLocaleString()} lps`
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.grafico {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 10px;
}

.canvas-wrapper {
  min-width: 600px;
  height: 400px;
}
</style>
